import axios from "@/api/axios";
import qs from "qs";

const get_roomlist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    roomlistcnt: null,
    roomlist: [
      {
        roomnum: null,
        roomname: null,
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/booking/roomlist",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
    // params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const get_playerlist = async (gameno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    playercnt: null,
    playerlist: [
      {
        playernum: null,
        playername: null,
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/room/playerlist/" + gameno,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
  };
  await axios(options).then((response) => {
    // alert(gameno);
    // console.log(response);
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const roundList = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: 1,
    pagesize: 10,
    playlistcnt: null,
    playlist: [
      {
        no: null,
        roomno: null,
        playerno: null,
        nickname: null,
        playercnt: null,
        coursename: null,
        hole: null,
        starttime: null,
        endtime: null,
        status: null,
        gameno: null,
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/room/roundlist",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
    params: params,
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};

// const scoreCardOne = async (playernum, result) => {
//   let finalData = {
//     code: 200,
//     message: "Ok",
//     scorecardinfo: [],
//     scorecardsubcourseinfo: [],
//     scorecardstats: [],
//     scorecardscore: [],
//     scorecardtotal: [],
//   };
//   const options = {
//     method: "GET",
//     url: "/room/scorecard/" + playernum,
//     // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
//     // data: qs.stringify({})
//   };

//   await axios(options).then((response) => {
//     if (response.data.code === 200) {
//       // console.log(response.data);
//       finalData.scorecardinfo = response.data.scorecardinfo;
//       finalData.scorecardsubcourseinfo = response.data.scorecardsubcourseinfo;
//       finalData.scorecardstats = response.data.scorecardstats;
//       finalData.scorecardscore = response.data.scorecardscore;
//       finalData.scorecardtotal = response.data.scorecardtotal;

//       result(finalData);
//     } else {
//       result(null);
//     }
//   });
// };
const scoreCardAll = async (gameno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    scorecardinfo: [],
    scorecardplayersubcourseinfo: [],
    // 'scorecardholepar': [],
    // 'scorecardholetotal': [],
    scorecardplayerlistcnt: null,
    scorecardplayerlist: [],
    // 'scorecardscorelist': []
  };
  const options = {
    method: "GET",
    url: "/room/scorecardall/" + gameno,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData.scorecardinfo = response.data.scorecardinfo;
      finalData.scorecardplayersubcourseinfo =
        response.data.scorecardplayersubcourseinfo;

      finalData.scorecardplayerlistcnt = response.data.scorecardplayerlistcnt;
      finalData.scorecardplayerlist = response.data.scorecardplayerlist;
      // finalData.scorecardscorelist = response.data.scorecardscorelist

      result(finalData);
    } else {
      result(null);
    }
  });
};

const get_memberscorecard = async (player_pk, define1_pk, result) => {
  let finalData = {
    code: "",
    message: "",
    scorecardinfo: {},
    scorecardstats: {},
    scorecardscore: {},
    scorecardtotal: {},
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url:
      process.env.VUE_APP_API_URL +
      "/tournament/scorecard/" +
      player_pk +
      "/" +
      define1_pk,
    //url: 'http://localhost/test.php',
    headers: { Authorization: "Bearer " + token },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_memberscorecard", err);
    result(false, err);
  }
};

export default {
  get_roomlist,
  get_playerlist,
  roundList,

  scoreCardAll,
  get_memberscorecard,
};
